import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RenderFilterForm from "../../utils/filterForm";
import {loadCompaniesForSelect} from "../../actions/Company/forSelect";
import {loadPartnersForSelect} from "../../actions/Partner/forSelect";
import {currentUserHasRole} from "../../utils/auth";

class FilterForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    error: PropTypes.string
  };

  componentDidMount() {
    this.props.loadCompaniesForSelect();
    if (currentUserHasRole('ROLE_SUPER_ADMIN')) {
      this.props.loadPartnersForSelect();
    }
  }

  render() {
    const statuses = [
      {value: 'active', text: 'Active'},
      {value: 'inactive', text: 'Inactive'},
      {value: 'pending', text: 'Pending'},
    ];

    const roles = [
      {value: 'partner-admin', text: 'Partner Admin'},
      {value: 'company-admin', text: 'Company Admin'},
      {value: 'company-employee', text: 'Company Employee'},
      {value: 'company-hiring-manager', text: 'Company Hiring Manager'},
      {value: 'company-user', text: 'Company User'},
      {value: 'candidate', text: 'Candidate'},
    ];

    if (currentUserHasRole('ROLE_SUPER_ADMIN')) {
      roles.push({value: 'super-admin', text: 'Super Admin'});
    }

    const fields = [
      {'name': 'id', 'label': 'ID', 'placeholder': 'ID', 'type': 'number'},
      {'name': 'firstName', 'label': 'First Name', 'placeholder': 'First Name', 'type': 'text'},
      {'name': 'lastName', 'label': 'Last Name', 'placeholder': 'Last Name', 'type': 'text'},
      {'name': 'email', 'label': 'Email Address', 'placeholder': 'Email Address', 'type': 'text'},
      {'name': 'phoneNumber', 'label': 'Phone Number', 'placeholder': 'Phone Number', 'type': 'text'},
      {'name': 'status', 'label': 'Status', 'placeholder': 'Status', 'type': 'selectSearch', 'options': statuses},
      {'name': 'company', 'label': 'Company', 'placeholder': 'Company', 'type': 'selectSearch', 'options': this.props.companies},
      {'name': 'role', 'label': 'Role', 'placeholder': 'Role', 'type': 'selectSearch', 'options': roles},
    ];

    if (currentUserHasRole('ROLE_SUPER_ADMIN')) {
      fields.push({'name': 'partner', 'label': 'Partner', 'placeholder': 'Partner', 'type': 'selectSearch', 'options': this.props.partners});
    }

    return (
      <RenderFilterForm {...this.props} fields={fields} />
    );
  }
}

const mapStateToProps = state => {
  let companies = state.company.forSelect.retrieved;
  let partners = state.partner.forSelect.retrieved;

  return { companies, partners };
};

const mapDispatchToProps = dispatch => ({
  loadCompaniesForSelect: () => dispatch(loadCompaniesForSelect('@id')),
  loadPartnersForSelect: () => dispatch(loadPartnersForSelect('@id')),
});

FilterForm = reduxForm({
  form: 'users',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(FilterForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterForm);
